import { useSearchParams } from 'next/navigation';
import { useRouter } from '@/hooks/general/useRouter/useRouter';
import { useAuthStore } from '@/store/authStore/authStore';

export const useLogout = () => {
    const searchParams = useSearchParams();
    const { push } = useRouter();

    const { logout } = useAuthStore((state) => ({
        logout: state.logout,
    }));

    const handleLogout = async () => {
        await logout();
        const fromQuery = searchParams ? searchParams.getAll('from') : undefined;
        const fromUrl = Array.isArray(fromQuery) ? fromQuery.pop() : fromQuery;
        if (fromUrl) {
            push(`/login?to=${fromUrl}`);
        } else {
            push('/login');
        }
    };

    return { handleLogout };
};
